var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-action',[_c('v-simple-checkbox',{attrs:{"value":_vm.value,"color":"primary"},on:{"input":function($event){return _vm.handleInput(!_vm.value)}}})],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.__('Indemnização', 'budget'))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }